import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import { IOpioidConversionVersion, IRiskThreshold } from '../../entities/MME/MME';

export interface ICreateOpioidConversionVersion {
    versionName: string;
    description: string;
    activateImmediately: boolean;
    conversionFactors: IConversionFactorInput[];
    specialFormulaConfigs: ISpecialFormulaConfigsInput;
    riskThresholds?: IRiskThreshold;
}

export interface IConversionFactorInput {
    drugID: number;
    drugName: string;
    routeID: number;
    routeName: string;
    conversionFactor: number;
    dose: number | null;
    unitID: number;
    unitName: string;
    requiresTransdermalFentanylCalculation: boolean;
    requiresMethadoneCalculation: boolean;
    requiresBuprenorphineCalculation: boolean;
}

export interface ISpecialFormulaConfigsInput {
    transdermalFentanyl: any;
    methadone: any;
    buprenorphine: any;
}

export class OpioidConversionVersionApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/OpioidConversionVersion`;

    public static async getAll(): Promise<IOpioidConversionVersion[]> {
        return this.sendApiRequest<IOpioidConversionVersion[]>({
            method: HttpMethodEnum.GET,
            path: this.baseApiUrl,
        });
    }

    public static async getActiveVersion(): Promise<IOpioidConversionVersion> {
        return this.sendApiRequest<IOpioidConversionVersion>({
            method: HttpMethodEnum.GET,
            path: `${this.baseApiUrl}/Active`,
        });
    }

    public static async getById(id: number): Promise<IOpioidConversionVersion> {
        return this.sendApiRequest<IOpioidConversionVersion>({
            method: HttpMethodEnum.GET,
            path: `${this.baseApiUrl}/${id}`,
        });
    }

    public static async activateVersion(id: number): Promise<any> {
        return this.sendApiRequest<any>({
            method: HttpMethodEnum.PUT,
            path: `${this.baseApiUrl}/${id}/Activate`,
        });
    }

    public static async getFormulaConfig(id: number, formulaType: string): Promise<any> {
        return this.sendApiRequest<any>({
            method: HttpMethodEnum.GET,
            path: `${this.baseApiUrl}/${id}/FormulaConfig/${formulaType}`,
        });
    }

    public static async createVersion(model: ICreateOpioidConversionVersion): Promise<any> {
        return this.sendApiRequest<any>({
            method: HttpMethodEnum.POST,
            path: this.baseApiUrl,
            data: model as any,
        });
    }

    public static async updateVersion(id: number, model: ICreateOpioidConversionVersion): Promise<any> {
        return this.sendApiRequest<any>({
            method: HttpMethodEnum.PUT,
            path: `${this.baseApiUrl}/${id}`,
            data: model as any,
        });
    }

    public static async canDeleteVersion(id: number): Promise<{ canDelete: boolean; isUsedInCalculations: boolean; isActive: boolean; message: string }> {
        return this.sendApiRequest<{ canDelete: boolean; isUsedInCalculations: boolean; isActive: boolean; message: string }>({
            method: HttpMethodEnum.GET,
            path: `${this.baseApiUrl}/${id}/CanDelete`,
        });
    }

    public static async deleteVersion(id: number): Promise<any> {
        return this.sendApiRequest<any>({
            method: HttpMethodEnum.DELETE,
            path: `${this.baseApiUrl}/${id}`,
        });
    }
}
